import routerOptions0 from "/var/jenkins_home/workspace/picmastudio-web-test-2/node_modules/.pnpm/registry.npmmirror.com+nuxt@3.9.1_rollup@4.9.4_sass@1.69.7_vite@5.0.11/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}